import { Link } from "react-router-dom";
import { useWholesaleAccount } from "@/hooks/useWholesaleAccount";
import { tierLabel } from "@/lib/wholesalePricing";
import { Sparkles } from "lucide-react";

export const WholesaleBanner = () => {
  const { account } = useWholesaleAccount();
  if (!account || !account.active) return null;

  return (
    <div className="w-full bg-primary text-primary-foreground text-xs sm:text-sm">
      <div className="container flex items-center justify-between gap-3 py-2">
        <div className="flex items-center gap-2 min-w-0">
          <Sparkles className="h-3.5 w-3.5 flex-shrink-0" />
          <span className="truncate">
            <strong>{tierLabel(account.tier)} wholesale</strong> · {account.discount_percent}% off retail applied
          </span>
        </div>
        <Link
          to="/wholesale/account"
          className="underline underline-offset-2 hover:opacity-80 whitespace-nowrap flex-shrink-0"
        >
          My account
        </Link>
      </div>
    </div>
  );
};
